import type {CompRef, CustomCssUpdateArg, PS} from '@wix/document-services-types'
import type {BuilderStyleExtensionAPI} from '@wix/document-manager-extensions/dist/src/extensions/builderComponents/builderStyle'

const getCompAppData = (ps: PS, componentType: string) => ps.extensionAPI.platform.getBuilderCompAppData(componentType)

const customCssUpload = async (ps: PS, _compRef: CompRef, customCssItem: CustomCssUpdateArg): Promise<void> => {
    try {
        const {builderStyle} = ps.extensionAPI as BuilderStyleExtensionAPI
        const uploadResult = await builderStyle.component.uploadCustomCss(customCssItem)
        ps.setOperationsQueue.asyncPreDataManipulationComplete(uploadResult)
    } catch (e) {
        const err = e instanceof Error ? e : new Error(String(e))
        ps.setOperationsQueue.asyncPreDataManipulationComplete(null, err)
    }
}

export default {
    getCompAppData,
    customCssUpload
}
